import React, { useMemo } from "react";
import PropTypes from "prop-types";
import Icon from "../../../../components/Icon";
import { FormatInt } from "../../../../utils/FormatData";
import _Input from "../../../../components/generic/_Input";
import _Select from "../../../../components/generic/_Select";
import _Switch from "../../../../components/generic/_Switch";
import { SelectAndSearch } from "../../../../components/ui/Form/SelectAndSearch";
import { classNames, errorLabels } from "../../../../utils/helpers";
import { ErrorMessage } from "../../../../utils/toastify";
import _Button from "../../../../components/generic/_Button";
import { usePartners, useCarriers, useDownloadCsv } from "../../hooks";

const CardSummary = ({ value, label, type }) => {
  return (
    <div className={"bg-gray-100 flex flex-col px-4 py-2 rounded-lg"}>
      <span
        className={classNames("text-lg font-bold", {
          "text-gray-700": type === "total",
          "text-green-700": type === "valid",
          "text-red-700": type === "invalid",
          "text-yellow-700": type === "duplicate",
        })}
      >
        {FormatInt(value) || 0}
      </span>
      <span className="flex items-center justify-start text-sm text-gray-500">
        {" "}
        {label}{" "}
      </span>
    </div>
  );
};
const StepFour = ({ formik, summary, fieldErrors }) => {
  const { data: dataPartners } = usePartners({
    enabled: formik.values.step === 4,
  });
  const { data: dataCarriers } = useCarriers({
    enabled: formik.values.step === 4,
  });


  console.log("fieldErrors", fieldErrors);

  const { download: downloadErrors } = useDownloadCsv(
    fieldErrors,
    "errors.csv",
  );

  const cards = useMemo(() => {
    const ARRAY_SUMMARY = [
      {
        value: summary?.summary?.total,
        label: "Registros totales",
        type: "total",
      },
      {
        value: summary?.summary?.valid,
        label: "Registros válidos",
        type: "valid",
      },
      {
        value: summary?.summary?.invalid,
        label: "Registros inválidos",
        type: "invalid",
      },
      {
        value: summary?.summary?.duplicates.phone,
        label: "Teléfonos duplicados",
        type: "duplicate",
      },
      {
        value: summary?.summary?.valid,
        label: "Contactos",
        type: "total",
      },
    ];

    if (formik.values.validEmail) {
      ARRAY_SUMMARY.splice(1, 0, {
        value: summary?.summary?.duplicates.email,
        label: "Correos duplicados",
        type: "duplicate",
      });
    }

    return ARRAY_SUMMARY;
  }, [formik.values.validEmail, summary]);
  const onValidate = async () => {
    try {
      const isValid = await formik.validateForm();
      const errors = errorLabels(isValid);
      if (Object.keys(isValid).length !== 0) {
        throw new Error(`Campos inválidos: ${errors}`);
      }

      formik.submitForm();
    } catch (error) {
      ErrorMessage(error.message);
    }
  };

  return (
    <div className="flex flex-col">
      <div className="border rounded-lg px-4 py-2 my-2">
        <div className="grid grid-cols-3 gap-4">
          <_Input
            title="Nombre"
            required
            onChange={formik.handleChange}
            value={formik.values.name}
            id="name"
            name="name"
            errors={formik.errors.name}
            isError={formik.errors.name ? true : false}
          />

          <SelectAndSearch
            title="Partner"
            name="uid_partner"
            id="uid_partner"
            value={formik.values.uid_partner}
            handleChange={(e) => formik.setFieldValue("uid_partner", e)}
            options={[
              {
                value: "",
                label: "Seleccione un partner",
                disabled: true,
              },
              ...dataPartners.map((item) => {
                return {
                  value: item.uidpartner,
                  label: item.name,
                };
              }),
            ]}
            errors={formik.errors.uid_partner}
            isError={formik.errors.uid_partner ? true : false}
          />

          <_Select
            title="Operadora"
            name="idcarrier"
            id="idcarrier"
            value={formik.values.idcarrier}
            onChange={formik.handleChange}
            options={[
              {
                value: "",
                label: "Seleccione una Operadora",
              },
              {
                value: "0",
                label: "Todos",
              },

              ...dataCarriers.map((item) => ({
                value: item.idcarrier,
                label: item.carrier,
              })),
            ]}
            errors={formik.errors.idcarrier}
            isError={formik.errors.idcarrier ? true : false}
          />
        </div>
        <div className="flex justify-between items-center rounded-lg px-4 py-2 border bg-gray-50 my-2">
          <div className="flex items-center gap-2">
            <span className="text-sm font-semibold text-gray-600">
              ¿Preprocesar información?
            </span>
            <Icon icon="info" />
          </div>
          <_Switch
            value={formik.values.preprocess}
            onChange={() =>
              formik.setFieldValue("preprocess", !formik.values.preprocess)
            }
          />
        </div>
        <div className="flex justify-between items-center rounded-lg px-4 py-2 border bg-gray-50">
          <div className="flex items-center gap-2">
            <span className="text-sm font-semibold text-gray-600">
              ¿Ocultar información?
            </span>
            <Icon icon="info" />
          </div>
          <_Switch
            value={formik.values.isHidden}
            onChange={() =>
              formik.setFieldValue("isHidden", !formik.values.isHidden)
            }
          />
        </div>
      </div>
      <div className="text-md font-semibold">Resumen</div>
      <div className="flex justify-end">
        {console.log(fieldErrors)}
        {fieldErrors.length > 0 && (
          <button
            className="group text-sm border-none h-[36px] w-[300px] bg-red-50 text-red-700 font-semibold flex items-center gap-2 rounded-lg px-3 py-1 hover:text-white hover:bg-red-700 transition-all ease-out my-1"
            onClick={downloadErrors}
          >
            <Icon
              icon="download"
              className="text-red-700 group-hover:text-white"
            />
            Descargar errores
          </button>
        )}
      </div>
      <div className="grid grid-cols-3 gap-2">
        {cards.map((item, index) => (
          <CardSummary key={index} {...item} />
        ))}
      </div>

      <div className="flex justify-end gap-2 my-2">
        <_Button
          style="primary"
          icon="save"
          className="w-[300px]"
          onClick={onValidate}
          disabled={formik.values.isOkToSave}
          loading={formik.isSubmitting}
          title="Guardar"
        />
      </div>
    </div>
  );
};

StepFour.propTypes = {
  data: PropTypes.array,
  formik: PropTypes.object,
  summary: PropTypes.object,
  fileInformation: PropTypes.object,
  dataCarriers: PropTypes.array,
  fieldErrors: PropTypes.array,
};

CardSummary.propTypes = {
  value: PropTypes.number,
  label: PropTypes.string,
  type: PropTypes.string,
};

export default StepFour;
